import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  CELL_BUY_IN,
  CELL_PLAYERS,
  CELL_PRIZE_POOL,
  CELL_START_STATE,
  TOURN_COLUMN_ID
} from '@swf/poker';

import type { SortByOptionProps } from './SortByOption/SortByOption';
import {
  TXTCLI_Ascending,
  TXTCLI_Buy_in,
  TXTCLI_Descending,
  TXTCLI_Enrolled,
  TXTCLI_Players,
  TXTCLI_Prize_Pool,
  TXTCLI_Start_State
} from './options.messages.json';

interface Option {
  id: SortByOptionProps['id'];
  desc: SortByOptionProps['desc'];
  label: SortByOptionProps['label'];
}

const DEFAULT = TOURN_COLUMN_ID.whenStart;

const OPTIONS: Option[] = [
  {
    id: CELL_START_STATE.accessor || DEFAULT,
    desc: false,
    label: <Translation {...TXTCLI_Start_State} />
  },
  {
    id: CELL_BUY_IN.accessor || DEFAULT,
    desc: true,
    label: (
      <>
        <Translation {...TXTCLI_Buy_in} />
        &nbsp;
        <Translation {...TXTCLI_Descending} />
      </>
    )
  },
  {
    id: CELL_BUY_IN.accessor || DEFAULT,
    desc: false,
    label: (
      <>
        <Translation {...TXTCLI_Buy_in} />
        &nbsp;
        <Translation {...TXTCLI_Ascending} />
      </>
    )
  },
  {
    id: CELL_PRIZE_POOL.accessor || DEFAULT,
    desc: true,
    label: (
      <>
        <Translation {...TXTCLI_Prize_Pool} />
        &nbsp;
        <Translation {...TXTCLI_Descending} />
      </>
    )
  },
  {
    id: CELL_PLAYERS.accessor || DEFAULT,
    desc: true,
    label: (
      <>
        <Translation {...TXTCLI_Players} />
        &nbsp;
        <Translation {...TXTCLI_Enrolled} />
      </>
    )
  }
];

export default OPTIONS;
